import { DialogContentText, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { MODULE_NAME } from '../../../strings'
import TwoFactorSupportInfo from '../../TwoFactorSupportInfo'
import { StepContent } from '../ReauthenticationDialog.style'

interface SupportInfoStepProps {
  onBack: () => void
}

// For users without access to their authenticator app
const SupportInfoStep = ({ onBack }: SupportInfoStepProps) => {
  const { t } = useTranslation(MODULE_NAME)

  return (
    <StepContent sx={{ pb: 3 }}>
      <Stack spacing={2.5}>
        <DialogContentText variant="body2" color="text.secondary">
          {t('twoFactor.support.description')}
        </DialogContentText>
        {/* Its Grid relies on negative margins, which Stack would reset */}
        <div>
          <TwoFactorSupportInfo onBack={onBack} />
        </div>
      </Stack>
    </StepContent>
  )
}

export default SupportInfoStep
